import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  RadioProps,
  SxProps,
  Theme,
  Typography
} from '@mui/material';
import { FC, SyntheticEvent } from 'react';
import { SelectOption } from '../select';

export type RadioOption = SelectOption & {
  /** A second, quieter line below the option text. */
  hint?: string;
};

type Props = {
  label?: string;
  name?: string;
  displayInline?: boolean;
  color?: RadioProps['color'];
  options: Array<RadioOption>;
  value: SelectOption['value'];
  sx?: SxProps<Theme>;
  onChange: (e: SyntheticEvent) => void;
};

export type RadioButtonProps = Props;

export const RadioButton: FC<Props> = ({
  label,
  name = 'radio-buttons',
  displayInline = true,
  color = 'heaven',
  options,
  value,
  sx,
  onChange
}) => {
  return (
    <FormControl>
      {label && <FormLabel>{label}</FormLabel>}
      <RadioGroup row={displayInline} value={value} onChange={onChange} name={name} sx={sx}>
        {options &&
          options.length > 0 &&
          options.map((option) => (
            <FormControlLabel
              key={String(option.value)}
              value={option.value}
              control={<Radio color={color} />}
              label={
                option.hint ? (
                  <span className="flex flex-col">
                    <span>{option.text}</span>
                    <span className="text-sm text-grey-600">{option.hint}</span>
                  </span>
                ) : (
                  option.text
                )
              }
              disabled={option.disabled}
            />
          ))}
        {options && options.length === 0 && (
          <Typography color="error">options are missing</Typography>
        )}
      </RadioGroup>
    </FormControl>
  );
};
